/** Pure helpers of the app shell (kept apart from the components so they can be unit-tested). */

/** Scroll distance (px) past which the top bar turns into glass. */
export const TOP_BAR_SCROLL_THRESHOLD = 8;

/** Width (px) of the sidebar column, margin included. The save bar hangs from it. */
export const SIDEBAR_COLUMN_WIDTH = 252;

/** Horizontal inset of the page content; the top bar text aligns with it. */
export const SHELL_GUTTER = 'clamp(34px, 2.6vw, 48px)';

/** True once the page scrolled strictly past `threshold`. */
export function isScrolledPast(scrollY: number, threshold: number = TOP_BAR_SCROLL_THRESHOLD): boolean {
  return scrollY > threshold;
}

/** Apple platforms show the command key; everything else shows Ctrl. */
export function isApplePlatform(platform: string): boolean {
  return /mac|iphone|ipad|ipod/i.test(platform);
}

/** Text of the key hint inside the search trigger. */
export function searchShortcutLabel(apple: boolean): string {
  return apple ? '⌘K' : 'Ctrl K';
}

/** The global shortcut that opens the search: Ctrl+K, or Cmd+K on Apple devices. */
export function isSearchShortcut(event: { key: string; ctrlKey: boolean; metaKey: boolean; altKey?: boolean }): boolean {
  return event.key.toLowerCase() === 'k' && (event.ctrlKey || event.metaKey) && !event.altKey;
}
